/* ═══════════════════════════════════════════════════════════════════════════
   🎵 postMusicWeb.js — the song under a post that has no video, in the browser.
   (The phone's twin is app/services/postMusicPlayer.ts.) One song at a time,
   started and stopped from the ▶ on the post's music pill; a card that leaves
   the page stops its song.
   ═══════════════════════════════════════════════════════════════════════════ */
let audio = null;
let current = null;
const subs = new Set();
const emit = () => subs.forEach((f) => { try { f(); } catch (_) { /* listener */ } });

export const playingPost = () => current;
export function subscribeMusic(fn) { subs.add(fn); return () => subs.delete(fn); }

export function stopMusic() {
  try { if (audio) audio.pause(); } catch (_) { /* gone */ }
  audio = null;
  current = null;
  emit();
}
export function stopIf(postId) { if (current === postId) stopMusic(); }

export function toggleMusic(postId, url, startMs = 0) {
  if (current === postId) { stopMusic(); return; }
  stopMusic();
  try {
    const a = new Audio(url);
    a.loop = true;
    if (startMs > 0) a.currentTime = startMs / 1000;
    audio = a;
    current = postId;
    emit();
    a.play().catch(() => { if (audio === a) stopMusic(); });
  } catch (_) { stopMusic(); }
}
